<template>
    <b-modal id="shopware6_manager_modal">
        <template slot="modal-title">Manage Shopware connection</template>
        <b-form ref="shopware_manager_modal_form" v-if="project_data.connections.indexOf('Shopware6') === -1">
            <b-form-group label="URL of the webshop">
                <b-form-input
                        id="webshop_url"
                        :state="validateWebshopUrl"
                        v-model="shopware_credentials.webshop_url"
                        required/>
                <b-form-invalid-feedback :state="validateWebshopUrl">
                    Webshop URL is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="The version of the api, API version is deprecated since shopware version 6.4. ">
                <b-form-input
                        id="api_version"
                        v-model="shopware_credentials.api_version"/>
            </b-form-group>
            <b-form-group label="The client id">
                <b-form-input
                        id="client_id"
                        :state="validateClientId"
                        v-model="shopware_credentials.client_id"
                        required/>
                <b-form-invalid-feedback :state="validateClientId">
                    Client id is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="The client Secret">
                <b-form-input
                        id="client_secret"
                        :state="validateClientSecret"
                        v-model="shopware_credentials.client_secret"
                        required/>
                <b-form-invalid-feedback :state="validateClientSecret">
                    Client Secret is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <hr/>
            <b-button block
                      variant="primary"
                      :disabled="authorizing"
                      @click="authorize">
                Authorize
            </b-button>
        </b-form>
        <div v-if="project_data.connections.indexOf('Shopware6') >= 0">
            <b-button block
                      variant="danger"
                      :disabled="clearing_credentials"
                      @click="clearCredentials">
                Clear credentials
            </b-button>
        </div>
    </b-modal>
</template>
<script>
    import ShopwareConnectionService from '../../../services/Shopware6ConnectionService';

    export default {
        props: {
            project_data: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                shopware_credentials: {
                    webshop_url: '',
                    client_id: '',
                    client_secret: '',
                    api_version: ''
                },
                authorizing: false,
                clearing_credentials: false
            }
        },
        methods: {
            checkFields() {
                if (this.shopware_credentials.webshop_url.length <= 0) return false;
                if (this.shopware_credentials.client_id.length <= 0) return false;
                if (this.shopware_credentials.client_secret.length <= 0) return false;
                return true;
            },
            authorize(modal) {
                if (this.$refs.shopware_manager_modal_form.checkValidity() && this.checkFields()) {
                    let self = this;
                    const body = Object.assign(
                        {project_id: this.project_data.project_id},
                        this.shopware_credentials
                    );
                    this.authorizing = true;

                    ShopwareConnectionService.authorize(body).then(res => {
                        if (res.data.success) {
                            self.shopware_credentials.webshop_url = '';
                            self.shopware_credentials.client_id = '';
                            self.shopware_credentials.client_secret = '';
                            self.shopware_credentials.api_version = '';
                            self.$emit('shopware-authorization-complete', this.project_data.project_id);
                        }
                        this.authorizing = false;
                    });
                } else {
                    modal.preventDefault();
                }
            },
            clearCredentials() {
                this.clearing_credentials = true;

                ShopwareConnectionService.clearCredentials(this.project_data.project_id).then(res => {
                    if (res.data.success) {
                        this.project_data.connections = this.project_data.connections.filter(p => p !== 'Shopware6');
                    }

                    this.clearing_credentials = false;
                });
            }
        },
        computed: {
            validateWebshopUrl() {
                return this.shopware_credentials.webshop_url.length > 0;
            },
            validateClientId() {
                return this.shopware_credentials.client_id.length > 0;
            },
            validateClientSecret() {
                return this.shopware_credentials.client_secret.length > 0;
            }
        }
    }
</script>
